import React, { useState, useMemo } from 'react';

import { Select, MenuItem, FormControl, InputLabel, Typography, Box } from '@mui/material';

import CustomImageComponent from '@/components/shared/custom/custom-image';
import { LEAGUES } from '@/constants/leagues';
import { getCompetitionImage, getCompetitionName } from '@/helpers/leagues-helper';

import JornadasTabTable from './jornadas-tab-table';

const estadisticas = [
    'Minutos',
    'Goles',
    'Asistencias',
    'Disparos a puerta',
    'Disparos entre los tres palos',
    'Tarjetas amarillas',
    'Tarjetas rojas',
    'Faltas cometidas',
    'Faltas recibidas',
    'Goles en propia puerta',
    'Paradas',
    'Penales fallados',
    'Penales anotados',
    'Penales parados',
];

const JornadasTab = ({ data, season, style }) => {
    const [statType, setStatType] = useState('minutos');
    const [selectedLeague, setSelectedLeague] = useState(LEAGUES.LA_LIGA);

    const handleStatTypeChange = (event) => {
        setStatType(event.target.value);
    };

    const handleLeagueChange = (event) => {
        setSelectedLeague(event.target.value);
    };

    const leagues = useMemo(() => {
        const leagueSet = new Set();
        data?.partidos.forEach((partido) => {
            leagueSet.add(partido.leagueId);
        });
        return ['all', ...Array.from(leagueSet)];
    }, [data]);

    return (
        <div>
            <Typography variant="h3" gutterBottom className="mb-25" style={{ fontWeight: 600 }}>
                Jornadas {season > 0 ? `de la temporada ${season}/${season + 1}` : ''}
            </Typography>

            {/* Contenedor de filtros */}
            <Box sx={{ display: { xs: 'block', md: 'flex' }, gap: { xs: 2, md: 2 }, mb: 3 }}>
                <FormControl
                    sx={{
                        flex: { md: 1 },
                        minWidth: 120,
                        width: { xs: '100%', md: '50%' },
                        marginBottom: '16px',
                    }}
                    variant="standard"
                >
                    <InputLabel id="league-select-label">Competición</InputLabel>
                    <Select
                        labelId="league-select-label"
                        id="league-select"
                        value={selectedLeague}
                        onChange={handleLeagueChange}
                        variant="standard"
                    >
                        {leagues.map((leagueId) => (
                            <MenuItem key={leagueId} value={leagueId}>
                                {leagueId !== 'all' && (
                                    <CustomImageComponent
                                        src={getCompetitionImage(leagueId)}
                                        alt={getCompetitionName(leagueId)}
                                        width={20}
                                        height={20}
                                        style={{ marginRight: '4px' }}
                                    />
                                )}
                                {leagueId !== 'all' ? getCompetitionName(leagueId) : 'Todas'}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl
                    sx={{
                        flex: { md: 1 },
                        minWidth: 120,
                        width: { xs: '100%', md: '50%' },
                    }}
                    variant="standard"
                >
                    <InputLabel id="stat-type-label">Estadística</InputLabel>
                    <Select
                        labelId="stat-type-label"
                        id="stat-type"
                        value={statType}
                        onChange={handleStatTypeChange}
                        variant="standard"
                    >
                        {estadisticas.map((estadistica) => (
                            <MenuItem key={estadistica} value={estadistica.toLowerCase()}>
                                {estadistica}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>

            <JornadasTabTable style={style} data={data} selectedLeague={selectedLeague} statType={statType} />
        </div>
    );
};

export default JornadasTab;
